import { FC, useMemo } from 'react'
import CommonLayout from 'components/layouts/CommonLayout'
import CardLayout from 'components/layouts/CardLayout'
import LoginForm from 'components/molecules/forms/LoginForm'
import { DeviceVerificationForm } from 'components/features/pfm/DeviceVerificationForm/DeviceVerificationForm'
import * as styles from 'components/features/pfm/Login/Login.css'
import { AnyDict } from 'interfaces'
import Anchor from 'components/atoms/navigation/Anchor'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { ONBOARDING_REGISTER } from 'constants/pages'
import { PageMeta } from 'components/features/pfm/PageMeta/PageMeta'

export type LoginStateProps = {
  deviceUnverified: boolean
  deviceFormInitialValues: AnyDict
}

type LoginProps = LoginStateProps

const Login: FC<LoginProps> = (props) => {
  const { deviceUnverified, deviceFormInitialValues } = props

  const formChild = useMemo(() => {
    if (deviceUnverified) {
      return (
        <DeviceVerificationForm initialValues={ deviceFormInitialValues } />
      )
    }

    return (
      <LoginForm />
    )
  }, [deviceFormInitialValues, deviceUnverified])

  return (
    <Anchor placement='login'>
      <CommonLayout>
        <PageMeta
          title='Login | Status Money'
          description='Log into your Status Money account.'
        />
        <CardLayout title='Log In'>
          <div className={ styles.contentWrapper }>
            { formChild }
            <div className={ styles.onboardingInvitation }>
              Don't have an account?
              Please <NavigationLink to={ ONBOARDING_REGISTER } className={ styles.onboardingLink }>sign up</NavigationLink>.
            </div>
          </div>
        </CardLayout>
      </CommonLayout>
    </Anchor>
  )
}

export default Login
